export const WAITLIST_LIMIT = [5, 10, 20];
export const WAITLIST_PLUG_TIME = [10, 20, 30,60];
export const DEFAULT_WAITLIST_CONFIGURE =  {status: true, minutes_to_plugin: 10, max_waitlist_allowed: 5};
export  const WAITLIST_STATUS = [{value: true, label: "waitlist.enable"}, {value: false, label: "waitlist.disable"}];
export const WAITLIST_ERROR_MESSAGE: any = {'WL-004' : "waitlist.error.wl004", 'WL-001' : 'waitlist.error.wl001'};